import styled from "@emotion/styled";
import { GridLegacy as Grid, Typography } from "@mui/material";

export const ReplacementHeaderText = styled(Typography)({
	fontFamily: "canada-type-gibson, sans-serif",
	color: "var(--text-primary)",
	fontWeight: "var(--font-weight-regular)",
	fontSize: "var(--font-size-6)",
	margin: 0,
	display: "inline-block"
});

export const GenerateStepperWrapper = styled(Grid)(({ theme }) => ({
	minWidth: "20rem",
	margin: ".5rem 0",
	[theme.breakpoints.up("md")]: {
		justifyContent: "flex-end"
	}
}));

export const SelectPartsLineItemWrapper = styled.div(({ theme }) => ({
	color: theme.palette.text.primary,
	fontSize: "0.75rem",
	fontWeight: 400,
	letterSpacing: 1,
	margin: "0 0 1rem 0",
	textTransform: "uppercase"
}));

export const SkuDescriptionContainer = styled.div({
	display: "flex",
	flexDirection: "column"
});
